import ConfirmationScheduleRoot from '../../components/pages/ConfirmationSchedule';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';

/**
 * @deprecated
 */
const ConfirmationSchedule = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <ConfirmationScheduleRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default ConfirmationSchedule;
